module.exports = __webpack_public_path__ + "static/media/15UN-Habitat12.a0b22ad4.jpg";